var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from "react";
import styled from "styled-components";
import { get } from "lodash";
import { FormattedMessage } from "@irati/utils/lang";
import { error as errorColor } from "../global/colors";
var StyledUl = styled.ul(templateObject_1 || (templateObject_1 = __makeTemplateObject(["color: ", ";"], ["color: ", ";"])), errorColor);
var SetPasswordError = function (_a) {
    var error = _a.error;
    var data = get(error, "response.data.data");
    if (!data)
        return null;
    var lengthCheck = data.lengthCheck, hasUppercase = data.hasUppercase, hasLowercase = data.hasLowercase, hasNumber = data.hasNumber, scoreCheck = data.scoreCheck, minLength = data.minLength;
    return React.createElement(StyledUl, null,
        lengthCheck === false && React.createElement("li", null,
            React.createElement(FormattedMessage, { id: "errors.setPassword.lengthCheck", values: { length: minLength } })),
        hasUppercase === false && React.createElement("li", null,
            React.createElement(FormattedMessage, { id: "errors.setPassword.hasUppercase" })),
        hasLowercase === false && React.createElement("li", null,
            React.createElement(FormattedMessage, { id: "errors.setPassword.hasLowercase" })),
        hasNumber === false && React.createElement("li", null,
            React.createElement(FormattedMessage, { id: "errors.setPassword.hasNumber" })),
        scoreCheck === false && React.createElement("li", null,
            React.createElement(FormattedMessage, { id: "errors.setPassword.scoreCheck" })));
};
export default SetPasswordError;
var templateObject_1;
